import cartMutations from './mutations.js';
import cartActions from './actions.js';
import cartGetters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            cart: [],
            kits: [],
            ordered_items: [],
            backordered_items: [],
            totals: [
                {
                    subtotal: 0,
                    coretotal: 0,
                    taxtotal: 0,
                    shippingtotal: 0,
                    ordertotal: 0,
                    backordered_total: 0,
                    shipping_handling_total: 0,
                    discounttotal: 0,
                }
            ],
            promo_code: [],
            // {
            //     code    : '',
            //     fixed_dc: 0,
            //     percent_dc: 0,
            // },
            tax_rate: 0,
            order_notes: null,
            promocode: '',
            po_required: 'N',
            cart_expiration: null,
            cedkoe: '',

            // Billing Details
            email: '',
            phone: '',
            billingname: '',
            billingaddress1: '',
            billingaddress2: '',
            billingcity: '',
            billingstate: '',
            billingcountry: '',
            billingzip: '',
            billingphone: '',
            cust_location: '',

            // Shipping Details
            shippingDifferent: false,
            carrier: '',
            shippingname: '',
            shippingaddress1: '',
            shippingaddress2: '',
            shippingcity: '',
            shippingstate: '',
            shippingcountry: '',
            shippingzip: '',
            shippingphone: '',
            ordernotes: '',

            // Order Details
            paymenttype: '',
            purchaseorder: '',

            // cc details
            cc_token: null,
            cc_fname: null,
            cc_lname: null,
            cc_cvv: null,
            cc_exp_mo: null,
            cc_exp_yr: null,
            cc_address: null,
            cc_city: null,
            cc_state: null,
            cc_zip: null,
            cc_country: null,
            cc_saved_cc: '',
            to_save_new_cc: 'N',
            cc_saved_id: '',
            
            ordernumber: '',
            orderdate: '',
            paymentmethod: '',
        }
    },
    mutations: cartMutations,
    actions: cartActions,
    getters: cartGetters
};
